import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Spacer } from '../../../components';
import { formatNumber } from '../../../helpers/utilityFunctions';

interface BreakdownHeaderProps {
  reportName?: string;
  activeUserCount: number;
}

const BreakdownHeader: React.FC<BreakdownHeaderProps> = ({ reportName, activeUserCount }) => {
  return (
    <Grid mb={2}>
      {reportName && (
        <>
          <Typography variant='p24' color='secondary.main'>
            {reportName}
          </Typography>
          <Spacer height='xs' />
        </>
      )}

      <Grid display='flex' flexDirection='column'>
        <Typography variant='p24Bold' color='secondary.main'>
          {formatNumber(activeUserCount)}
        </Typography>
        <Typography variant='p16' color='secondary.main'>
          Active users
        </Typography>
      </Grid>
    </Grid>
  );
};

export default BreakdownHeader;
